import { useState } from "react";
import {
  AmazonItemsApi,
  ResponseRegistAmazonItemsResponse,
  RequestRegistAmazonItemsRequest,
  AmazonItemsRegisterAmazonItemsPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiRegisterAmazonItems = () => {
  const [_, setRegistedItem] =
    useState<ResponseRegistAmazonItemsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const registerAmazonItems = async (req: RequestRegistAmazonItemsRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonItemsRegisterAmazonItemsPostRequest = {
        req,
      };

      const api = new AmazonItemsApi(config);
      const response = await api.amazonItemsRegisterAmazonItemsPost(request);
      console.log(response);
      setRegistedItem(response);
      return response;
    } catch (err) {
      setError("商品の登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { registerAmazonItems, error, isLoading };
};
